import axios from 'axios'
import store from '../store'
import config from '@/helpers/config'

export default {
  getCustomReportsTweets (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsCountByCountry (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-count-by-country' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsCountBySentiment (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-count-by-sentiment' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsTypesCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-types-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsImpressionsCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-impressions-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsVolume (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-volume' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTweetsImpressionsVolume (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/tweets-impressions-volume' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTwitterUsers (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/twitter-users' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTwitterUsersCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/twitter-users-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTwitterUserEvolution (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/twitter-user-evolution' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsTwitterHashtags (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/twitter-hashtags' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsArticles (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/articles' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsArticlesCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/articles-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsArticlesCountBySentiment (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/articles-count-by-sentiment' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsArticlesWithoutStories (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/articles-without-stories' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsArticlesWithoutStoriesCount (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/articles-without-stories-count' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsStories (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/stories' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getCustomReportsStoriesStats (context, query) {
    return axios.get(
      config.apiUrl + '/custom-reports/stories-stats' + query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersWordCloud (context, payload) {
    return axios.get(
      config.apiUrl + '/users/word-cloud/200' + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsers (context, payload) {
    return axios.get(
      config.apiUrl + '/users/with-all' + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjects (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-users' + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateProject (context, payload) {
    return axios.put(
      config.apiUrl + '/projects/' + payload.id + '?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addProject (context, payload) {
    return axios.post(
      config.apiUrl + '/projects', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  createProject (context, payload) {
    return axios.post(
      config.apiUrl + '/projects' + '?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteProject (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/projects/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateUser (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/users/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addUser (context, payload) {
    return axios.post(
      config.apiUrl + '/users', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteUser (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/users/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateUserRoles (context, payload) {
    return axios.put(
      config.apiUrl + '/users/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getRoles (context, payload) {
    return axios.get(
      config.apiUrl + '/roles/with-all' + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addRole (context, payload) {
    return axios.post(
      config.apiUrl + '/roles', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteRole (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/roles/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateRole (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/roles/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getGNIPRules (context, payload) {
    return axios.get(
      config.apiUrl + '/gnip/rules' + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addGNIPRule (context, payload) {
    return axios.post(
      config.apiUrl + '/gnip/rules', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteGNIPRule (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/gnip/rules/' + payload.tag + (payload.value ? '/' + encodeURIComponent(payload.value) : ''),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateGNIPRule (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/gnip/rules/' + payload.tag, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  validateGNIPRule (context, payload) {
    return axios.post(
      config.apiUrl + '/gnip/rules/validate', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  createDB (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/projects/creator', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  dropDB (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/projects/creator/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  importDB (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.post(
      config.apiUrl + '/projects/import', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js